// K135 LAPIS 3 — papan kesehatan kiriman WA + Telegram.
//
// ⛔ LAHIR DARI SENSUS PINTU (23 Sep 2026): `GET /api/papan-kerja/kesehatan` berdiri tanpa layar —
//    Owner hanya melihat ringkasan 24 jam di dasbor; KC dan Admin Produksi tidak melihat apa pun,
//    dan rincian kegagalan (sebab APA ADANYA) tidak tampil di mana pun. Pertanyaan papan ini:
//    "apakah pengiriman kami sedang RUSAK", bukan "pesan mana yang gagal" — tiga puluh kegagalan di
//    satu tempat terbaca sebagai satu insiden.
import React, { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { apiErrorMessage } from "../../lib/inventoryApi";
import { formatDateTime } from "../../lib/format";

// Label keadaan kiriman Telegram — kode mentah tidak tampil ke staf (K200 butir 6).
const LABEL_STATUS_TG = {
  FAILED: "Gagal",
  BELUM_DAFTAR: "Belum daftar Telegram",
  SENT: "Terkirim",
  PENDING: "Menunggu",
  DIBATALKAN: "Dibatalkan",
};

export default function PanelKesehatanKiriman() {
  const [buka, setBuka] = useState(false);
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  const muat = useCallback(async () => {
    setErr(null);
    try {
      const r = await api.get("/papan-kerja/kesehatan", { params: { jam: 24 } });
      setData(r.data);
    } catch (e) {
      setErr(apiErrorMessage(e, "Kesehatan kiriman gagal dimuat."));
    }
  }, []);
  useEffect(() => { muat(); }, [muat]);

  const sehat = data?.sehat;
  return (
    <div className={`rounded-xl border p-4 text-sm ${sehat === false ? "border-warning-soft-border bg-warning-soft" : "border-border"}`}
         data-testid="kesehatan-kiriman">
      <button type="button" className="w-full flex items-center justify-between font-semibold"
              onClick={() => setBuka(!buka)} data-testid="kesehatan-kiriman-toggle">
        <span>Kesehatan kiriman 24 jam — {err ? "gagal dimuat" : data ? (sehat ? "sehat" : `${data.masalah.length} masalah`) : "memuat…"}</span>
        <span className="text-xs text-muted-foreground">{buka ? "tutup" : "rincian"}</span>
      </button>
      {err && <p className="mt-2 text-danger">{err}</p>}
      {data && !sehat && (
        <ul className="mt-2 list-disc pl-5 space-y-0.5" data-testid="kesehatan-kiriman-masalah">
          {data.masalah.map((m, i) => <li key={i}>{m}</li>)}
        </ul>
      )}
      {buka && data && (
        <div className="mt-3 space-y-3">
          <div className="grid grid-cols-2 gap-2 text-xs">
            {/* T45: "sampai" = sampai di HP customer (atau sudah dibaca); "diserahkan ke WhatsApp" BELUM tentu sampai. */}
            <div>WhatsApp: sampai di HP {data.whatsapp?.sampai ?? "belum diketahui"} · diserahkan ke WhatsApp {data.whatsapp?.diserahkan ?? 0} · belum pasti {data.whatsapp?.belum_pasti ?? "belum diketahui"} · gagal {data.whatsapp?.gagal ?? 0} · macet {data.whatsapp?.pending_macet ?? 0}</div>
            <div>Telegram: terkirim {data.telegram?.terkirim ?? 0} · gagal {data.telegram?.gagal ?? 0} · belum daftar {data.telegram?.belum_daftar ?? 0} · susulan gagal {data.telegram?.susulan_gagal ?? 0}</div>
          </div>
          {(data.rincian?.whatsapp || []).length > 0 && (
            <table className="w-full text-xs" data-testid="kesehatan-rincian-wa">
              <thead className="text-muted-foreground"><tr><th className="text-left">WA · waktu</th><th className="text-left">jenis</th><th className="text-left">tujuan</th><th className="text-left">sebab (apa adanya)</th><th className="text-right">coba</th></tr></thead>
              <tbody>{data.rincian.whatsapp.map((x) => (
                <tr key={x.id} className="border-t border-border align-top">
                  <td className="whitespace-nowrap pr-2">{formatDateTime(x.created_at)}</td><td>{x.jenis}</td>
                  <td>{x.tujuan_samar}</td><td className="whitespace-pre-wrap">{x.galat_terakhir || "—"}</td><td className="text-right">{x.percobaan}</td>
                </tr>))}</tbody>
            </table>
          )}
          {(data.rincian?.telegram || []).length > 0 && (
            <table className="w-full text-xs" data-testid="kesehatan-rincian-tg">
              <thead className="text-muted-foreground"><tr><th className="text-left">Telegram · tanggal kerja</th><th className="text-left">keadaan</th><th className="text-left">sebab (apa adanya)</th><th className="text-right">coba</th></tr></thead>
              <tbody>{data.rincian.telegram.map((x) => (
                <tr key={x.id} className="border-t border-border align-top">
                  <td className="whitespace-nowrap pr-2">{x.tanggal_kerja}</td><td>{LABEL_STATUS_TG[x.status] || "—"}</td>
                  <td className="whitespace-pre-wrap">{x.gagal_alasan || "—"}</td><td className="text-right">{x.percobaan}</td>
                </tr>))}</tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
